export const GO_BUTTON_FOR_STOCK_OUT_ACTION = 'GO_BUTTON_FOR_STOCK_OUT_ACTION'
export const GO_BUTTON_FOR_STOCK_OUT_SUCCESS = 'GO_BUTTON_FOR_STOCK_OUT_SUCCESS'

export const STOCK_OUT_REPORT_ERROR_ACTION = 'STOCK_OUT_REPORT_ERROR_ACTION'